// src/PortfolioCard.jsx

export default function PortfolioCard({ item }) {
  return (
    <div className="portfolio-card">

      <a
        href={item.url}
        target="_blank"
        rel="noopener noreferrer"
        className="portfolio-image-wrap"
      >
        <a  href={item.url}
  target="_blank"
  rel="noopener noreferrer"
>
        <img
          src={item.image}
          alt={item.title}
          className="portfolio-image"
        />
      </a>
      </a>

      <h3 className="portfolio-title">{item.title}</h3>

      <p className="portfolio-role">
        <strong>{item.role}</strong>
      </p>

      <p className="portfolio-description">
        {item.description}
      </p>
    </div>
  );
}
